import { LOGIN_PATH, OIDC_CALLBACK_PATH } from "../oidc-routes";
import type { SharedOidcUnauthorizedRecoveryOptions } from "./types";

export function readBrowserLocationPath() {
  if (typeof window === "undefined") {
    return "/";
  }
  const { pathname = "/", search = "", hash = "" } = window.location;
  return `${pathname}${search}${hash}`;
}

export function isDefaultOidcAuthRoutePath(pathname: string) {
  return pathname === LOGIN_PATH || pathname === OIDC_CALLBACK_PATH;
}

export function createSharedOidcUnauthorizedRecovery(
  options: SharedOidcUnauthorizedRecoveryOptions,
) {
  const isAuthRoutePath = options.isAuthRoutePath ?? isDefaultOidcAuthRoutePath;
  const readRedirectPath = options.readRedirectPath ?? readBrowserLocationPath;
  return async function recoverUnauthorizedSession() {
    if (typeof window === "undefined") {
      return "failed" as const;
    }
    const currentPathname = String(window.location.pathname || "");
    if (isAuthRoutePath(currentPathname)) {
      return "failed" as const;
    }
    await options.startAuthorization(readRedirectPath(), { prompt: "none" });
    return "redirecting" as const;
  };
}
